import * as React from 'react'

function SvgMintWallet(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15 10a1 1 0 100-2 1 1 0 000 2z" fill="#00D37E" />
      <path
        d="M13 10V8c0-.6.4-1 1-1h3c0-1.1-.9-2-2-2H9.9c.1-.2.1-.3.1-.5C10 2.6 8.4 1 6.5 1S3 2.6 3 4.5c0 .2 0 .3.1.5H3c-1.1 0-2 .9-2 2v7h.7c.8 0 1.4-.6 1.5-1.3l.1-.5c.1-1.3 1.2-2.2 2.5-2.2h2.3c.2-.6.8-1 1.4-1 .8 0 1.5.7 1.5 1.5S10.3 12 9.5 12c-.7 0-1.2-.4-1.4-1H5.8c-.8 0-1.4.6-1.5 1.3l-.1.5c0 .5-.2.9-.5 1.2h1.4c.2-.6.8-1 1.4-1 .8 0 1.5.7 1.5 1.5S7.3 16 6.5 16c-.7 0-1.2-.4-1.4-1H1c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4h-3c-.6 0-1-.4-1-1zM7.7 6.8l.1.3c.1.3-.1.6-.4.7-.3.1-.7 0-.8-.3l-.1-.4-.3.1c-.3.1-.7 0-.7-.3s.1-.6.4-.7l1.3-.3c.2-.1.3-.3.3-.4 0-.2-.2-.3-.5-.2l-.6.1c-.8.2-1.7-.2-1.9-1-.2-.7.2-1.4.9-1.7l-.1-.3c-.1-.3.1-.6.4-.7.3-.1.6.1.7.4l.1.3.4-.1c.3-.1.6.1.7.4.1.3-.1.6-.4.6l-1.3.4c-.2 0-.3.2-.3.4s.2.3.5.2l.6-.2c.8-.2 1.7.2 1.9 1 .2.7-.2 1.4-.9 1.7z"
        fill="#00D37E"
      />
    </svg>
  )
}

export default SvgMintWallet
